<template>
  <div class="password-confirm" v-if="isLoggedIn">
    <form-area name="frm" :action="action" :method="method" novalidate="true">
      <input type="hidden" name="_token" :value="token">

      <p class="password-confirm__lead">下記のメールアドレスにパスワード変更用のURLを送信します。</p>
      <div class="password-confirm__email">{{ email }}</div>

      <ul class="note-list">
        <li class="note-list__item">※info@uranai.tvからパスワード変更用のURLを送信します。メールの設定により、迷惑メールフォルダに振り分けられる場合があります。</li>
        <li class="note-list__item">※キャリアメールをご利用の方でメールが届かない場合は、ドメイン指定を解除してください。</li>
      </ul>

      <div class="password-confirm__foot">
        <SubmitButton
          type="submit"
          text="送信"
        />
      </div>
    </form-area>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SubmitButton from '../partials/SubmitButton'

export default {
  name: 'UserAccountPasswordConfirm',
  components: {
    SubmitButton
  },
  props: {
    action: String,
    method: {
      type: String,
      default: 'POST'
    },
    token: String,
    email: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters([ 'isLoggedIn']),
  },
}
</script>

<style lang="scss" scoped>
@import '../../../../sass/commons/commonVariables.scss';

.password-confirm {
  color: $col_base_black;
  padding: 35px 4px 20px;
  line-height: 1.6;
  &__lead {
    margin: 0 0 15px;
    font-size: 13px;
  }
  &__email {
    font-weight: bold;
    font-size: 13px;
    text-align: center;
    margin: 0 0 26px;
    border: 1px solid $col_temp_gray3;
    padding: 8px 4px;
    border-radius: 5px;
  }
  &__foot {
    padding: 0 10px;
  }
}
.note-list {
  display: block;
  margin: 0 0 36px;
  padding: 0;
  color: $col_base_black;
  font-size: 11px;
  line-height: 1.5;
  &__item {
    display: block;
    text-align: justify;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/User/UserAccountPasswordConfirm.vue